module.exports = __webpack_public_path__ + "8fcdf603efa63bf6fd384387977f7251.svg";